import React, { useState, useEffect, memo, useRef } from 'react'
import styled from 'styled-components'
import LogMessage from './logMessage'
import InfiniteScroll from 'react-infinite-scroll-component';
import { throttle } from "../../utils/utils";
import defaultImg from '@/img/default.png'

const LogBox = styled.div`
  width: 100%;
  background: white;
  flex: 1;
  min-width: 304px;

  .no-more {
    width: 100%;
    height: 20px;
    line-height: 20px;
    text-align: center;
    margin-top: 15px;
    margin-bottom: 10px;
    color: #BFBFBF;
    font-size: 12px;

    ::before{
      background: none !important;
    }
  }

  .infinite-scroll-component {
    ::-webkit-scrollbar {
      width: 8px;
      height: 10px;
    }
    ::-webkit-scrollbar-track {
      border-radius: 2px;
      background-color: #fff;
    }
    ::-webkit-scrollbar-thumb {
      border-radius: 10px;
      background: #E8EBF6;

      &:hover{
        background: #9A9EBA;
      }
    }
    ::-webkit-scrollbar-corner {
      background: #000000;
    }
  }
`
const LogBody = styled.div``
const LogTitle = styled.div`
  .log-people {
    color: #595959;
    font-size: 12px;
    display: flex;
    align-items: center;
    img {
      width: 24px;
      height: 24px;
      border-radius: 5px;
    }
    .log-name {
      margin: 0 4px;
    }
  }
  .log-people-right {
    flex-direction: row-reverse;
  }
  .log-date {
    display: inline-block;
    font-size: 12px;
    color: #BFBFBF;
  }
  .log-action {
    display: inline-block;
    margin-left: 4px;
    border-radius: 2px;
    background: #E9E9E9;
    color: #595959;
    padding: 4px;
  }
`
const LoadMore = styled.div`
  height: 20px;
  line-height: 20px;
  color: #108EE9;
  font-size: 12px;
  margin-top: 15px;
  margin-bottom: 10px;
  text-align: center;
  cursor: pointer;
`
/**
 * @description log
 * @params 聊天记录对象
 * @description session
 * @params 当前操作的session对象
 */
const ChatLog = (props) => {
  const [logHeight, setLogHeight] = useState()

  const dataRef = useRef({
    log: {}
  }).current

  const { log, loadMore, message, source, handleChange, scrollType, type, reverse = true, inverse = true } = props
  const isImg = type === 3
  const isFile = type === 2

  let tempLog = JSON.parse(JSON.stringify(log))
  let trueLog = { list: [] }
  if (log.list && log.list.length) {
    // 好友客户群倒序展示
    let realList = reverse ? tempLog.list : tempLog.list.reverse()
    trueLog = {
      ...log,
      list: realList
    }
  }

  // type （1.表示内部员工发送，2.企微客户发送消息）
  useEffect(() => {
    const changeHeight = () => {
      let element = document.getElementById('log-box')
      element && setLogHeight(element.offsetHeight - 5)
    }
    if (log) {
      changeHeight()

      if (log.list && log.list.length > 0) {
        let targetMessage
        if (message && message.id) {
          const targetClicked = log.list.find(item => item.id === message.id)
          targetMessage = document.getElementById(`message-id-${targetClicked?.id}`);
        } else {
          if (scrollType === 'bottom') {
            targetMessage = document.getElementById(`message-id-${log.list[0].id}`)
          } else {
            let hasMore = document.getElementById('has-more')
            let noMore = document.getElementById('no-more')
            targetMessage = hasMore || noMore;
          }
        }
        // 未定位消息时不再滚动
        if (targetMessage && message?.mgsid) {
          const messageBox = document.querySelector('.infinite-scroll-component');
          const messageDom = messageBox.getBoundingClientRect();
            messageBox.scrollTo({
              top: targetMessage.offsetTop - messageDom.top + 20
            })
            // targetMessage.scrollIntoView()
        }
      }
    }
    window.addEventListener('resize', throttle(changeHeight, 500));
    return (() => {
      window.removeEventListener('resize', changeHeight)
      dataRef.log = log
    })
  }, [log])

  const getData = (condition) => {
    loadMore(condition)
  }
  const renderName = (type, wxUserName, externalUserName) => {
    if (type === null) {
      return '系统消息'
    }
    if (type === 1) {
      return externalUserName
    }
    if (type === 2) {
      return wxUserName
    }
  }

  if (props?.isEmpty) {
    return (
      <LogBox id={'log-box'}>
        <div
          className={'no-more'}
          id={'no-more'}
          style={{ width: '100%', textAlign: 'center' }}
        >
          共0条聊天记录
        </div>
      </LogBox>
    );
  }
  return (
    <LogBox id={"log-box"}>
      {
        // 加key原因 修改scrollTop方式无效 切换会话滚动条置顶
        logHeight && log.list && (
          <InfiniteScroll
            style={{ padding: "0 24px 50px 24px" }}
            dataLength={log.list.length}
            key={props?.session?.sessionId}
            hasMore={Boolean(log.nextPage) || Boolean(log.nextPageUp)}
            height={props.height ? `calc(100vh - ${props.height + 76}px)` : "calc(100vh - 76px)"}
            // lastMessage配合pageType的方式不再使用
            next={() => {
              // scroll时不需要定位消息 重置定位消息
              props?.clearCurrentMessage && props.clearCurrentMessage()
              getData({ pageSize: 50, pageType: 2 })
            }}
            // 消息正序展示 上滑加载更多
            inverse={inverse}
            scrollableTarget="log-box"
          >
            {/* {
              (log.nextPage || log.nextPageUp) && (
                <LoadMore onClick={() => getData({
                  lastMessageId: log.list[log.list.length - 1].id, pageSize: 50, pageType: 3
                })} id={'has-more'}>查看更多</LoadMore>
              )
            } */}
            {
              <div className={'no-more'} id={'no-more'}>共{log.total ? log.total : 0}条聊天记录</div>
            }
            { props.empty ? <div style={{ textAlign: 'center', width: '100%' }}>暂无记录</div> : <></> }
            <div key={trueLog?.list?.length}>
              { 
                trueLog.list.map((item) => {
                  const { sendType, msgTimeStr, wxUserName, externalUserName, isRevoked, action, id } = item
                  if (action === 2) {
                    // 撤回消息不显示
                    return null
                  }
                  return <LogBody key={id} id={`message-id-${id}`}>
                    <LogTitle>
                      <div className={`log-people log-people-${sendType === 2 ? "right": "left"}`}>
                        {
                          <img src={item.avatar || defaultImg} alt="头像" />
                        }
                        {
                          <span className='log-name' dangerouslySetInnerHTML={{ __html: renderName(sendType, wxUserName, externalUserName) }}></span>
                        }
                        <span className={'log-date'}>
                          {msgTimeStr}
                        </span>
                        {
                          isRevoked && (
                            <span className={'log-action'}>
                              已撤回
                            </span>
                          )
                        }
                      </div>
                    </LogTitle>
                    {source === 'search-sidebar' ?
                      <LogMessage message={item}
                        handleChange={handleChange}
                        source={source} renderType='search-sidebar' /> :
                      <LogMessage message={item} renderType='chat-log' />
                    }
                  </LogBody>
                })
              }
            </div>
          </InfiniteScroll>
        )
      }
    </LogBox>
  )
}

export default memo(ChatLog)
